import { Button, Grid, ListItemText, Paper, Select, Stack, TextField } from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import React, { useEffect, useState } from 'react';
import AthleteDisplay from './AthleteDisplay';
import { useAtomValue, useSetAtom } from 'jotai';
import { Athlete } from '../atoms/athlete';
import { nationsAtom } from '../atoms/nationsAtom';
import { athletesAtom } from '../atoms/athletesAtom';
import { Api } from '../providers/Api';
import AddStartlist from './AddStartlist';

const StartList = () => {

    const [bibFilter, setBibFilter] = useState('');
    const [natFilter, setNatFilter] = useState('');
    const [athFilter, setAthFilter] = useState('');
    const [showAddStartlist, setShowAddStartlist] = useState(false);
    const [selAthlete, setSelAthlete] = useState(null as Athlete);

    const [startlist, setStartlist] = useState(null);
     let filteredAthletes = startlist ? startlist : [];
    
        if (natFilter) {
            filteredAthletes = filteredAthletes.filter(x => { return x.nat.toLowerCase().startsWith(natFilter.toLowerCase()) });
        }
        if (athFilter) {
            filteredAthletes = filteredAthletes.filter(x => { return x.name.toLowerCase().indexOf(athFilter.toLowerCase()) >= 0});
        }
        if (bibFilter) {
            filteredAthletes = filteredAthletes.filter(x => { return x.bib == bibFilter});
        }
    

    return <Stack style={{ padding: 10 }}>
        <Stack direction={"row"} spacing={2}><Button onClick={() => {setShowAddStartlist(true)}}>Add Startlist</Button></Stack>
        <Stack direction={"row"} spacing={2}>
            <TextField placeholder='Bib' label="Bib" value={bibFilter} onChange={(ev) => { setBibFilter(ev.target.value) }} />
            <TextField placeholder='Nation' label="Nation" value={natFilter} onChange={(ev) => { setNatFilter(ev.target.value) }} />
            <TextField placeholder='Name' label="Name" value={athFilter} onChange={(ev) => { setAthFilter(ev.target.value) }} />
        </Stack>
        {showAddStartlist && <AddStartlist useStartlist={(sl) => {setStartlist(sl);setShowAddStartlist(false);}}/>}
        <Grid container spacing={2}>
            <Grid item xs={2}>
                <List sx={{
                    overflow: 'auto',
                    maxHeight: 700
                }}>
                    {filteredAthletes && filteredAthletes.map((ath) => {
                        return <ListItem disablePadding>
                            <ListItemButton selected={ath.id == selAthlete?.id} onClick={() => {
                                setSelAthlete(ath.matchedAthlete)
                            }}>
                                <ListItemText key={ath.id} primary={ath.bib + " " + ath.name} /></ListItemButton></ListItem>;
                    })}
                </List>
            </Grid>
            <Grid item xs={10}>
                {selAthlete && <AthleteDisplay athlete={selAthlete} />}
            </Grid>
        </Grid>

    </Stack>;
}
export default StartList;